import './App.css';
import Main from './main.js';
function App() {
  return (
    <Main />
  );
}

export default App;
